import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import _ from 'lodash';

import { makeStyles } from '@material-ui/core/styles';
// import CircularProgress from '@material-ui/core/CircularProgress';

import Quote from 'components/Quote';
import ParticipantLabel from '../participants/ParticipantLabel';
// import { loadClaimParent } from '../store/claims.slice';
import { focusClaim } from '../store/claims.slice';

const useStyles = makeStyles(theme => ({
  root: {

  },
}));

function ClaimParent(props) {
  const {
    className,
    loading,
    // parentId,
    parent,
    onClickParent,
    // onMount,
    // onDismount,
  } = props;
  const classes = useStyles();

  const handleClick = id => (event) => {
    event.preventDefault();
    onClickParent(id);
  };

  // const mount = useCallback(onMount, []);
  // const dismount = useCallback(onDismount, []);
  // useEffect(() => {
  //   mount();
  //   return () => dismount();
  // }, [mount, dismount]);

  // console.log('ClaimParent', props); // DEBUG

  if (_.isNull(parent)) return null;
  if (loading) return null;
  // if (loading) {
  //   return (
  //     <div className={classes.spinner}>
  //       <CircularProgress />
  //     </div>
  //   );
  // }

  return (
    // @todo <CircularProgress />
    <div className={clsx(classes.root, className)}>
      <Quote
        entity={parent}
        owner={<ParticipantLabel userId={parent.metadata.createdBy} />}
        // @todo click "offable"
        onClick={handleClick(parent.id)}
      />
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  const claimsState = state.discuss.claims;
  // const parentId = _.get(ownProps, 'parent.id', null);
  // @todo use a selector?
  return {
    // loading: _.get(claimsState, `byId['${ownProps.replyId}'].pending`, true), // HERE selector
    // parent: _.get(claimsState, `byId['${parentId}']`, null), // HERE selector
    parent: _.get(claimsState, `byId['${ownProps.parentId}']`, null), // HERE selector
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClickParent: id => dispatch(focusClaim(id)),
    // onMount: () => {
    //   // dispatch(loadClaimParent(ownProps.claimId));
    // },
    // onReload: () => {
    // },
    // onDismount: () => {
    // },
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClaimParent);
